export default __webpack_public_path__ + "static/entirepattern-7d9b67d01bef2ea31fc1739097cc7073.png";